import React from 'react';

const Footer = () => {
  return (
    <footer className="w-full py-4 px-2 text-center border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-black text-gray-600 dark:text-gray-400 text-sm mt-auto">
      <span>&copy; {new Date().getFullYear()}  <a 
          href="https://www.knoowl.ai/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 underline transition-colors duration-200"
        >
          Knoowl.ai
        </a>. All rights reserved.</span>   
    </footer>
  );
};

export default Footer; 